import { Teams } from '@watershed/constants/teams';
import { useOwner } from '@watershed/shared-frontend/hooks/useOwner';
import { withOptionalRouteParams } from '@watershed/shared-frontend/utils/withRouteParams';

import LoginPage from '../components/login/components/LoginPage';
import { Layouts } from '../layouts/LayoutEnum';
import RedirectAuthenticatedUsers from '../components/RedirectAuthenticatedUsers';

const LoginPageWithRouteParams = withOptionalRouteParams(LoginPage, [
  'authError',
  'email',
  'adminName',
  'adminEmail',
  'watershedGeneric',
]);

function LoginPageWrapper() {
  useOwner(Teams.ApplicationPlatform);
  return (
    <RedirectAuthenticatedUsers>
      <LoginPageWithRouteParams />
    </RedirectAuthenticatedUsers>
  );
}

LoginPageWrapper.layout = Layouts.LoggedOut;
export default LoginPageWrapper;
